import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Header from '../components/Header';
import Select from 'react-select';
import './ContactedPage.css';
import '../components/BackgroundWrapper';
import BackgroundWrapper from '../components/BackgroundWrapper';
import contacted from '../features/attackSurface/assets/contacted-icon.png';

const ContactedPage: React.FC = () => {
  const navigate = useNavigate();

  return (
    <BackgroundWrapper>
      <div className="contact-container">
        <Header showContactButton={false} />

        <main className="contact-main">
          {/* Left side */}
          <div className="contact-left">
            <h1 className="contact-title">
              Get In Touch
            </h1>
            <p className="contact-subtitle">
              Reach out to learn more about DeepKeep AI Security Platform
            </p>
          </div>

          {/* Right side */}
          <div className="contact-right contacted-message">
            <div className="contacted-icon-wrapper">
                <img src={contacted} alt="Success" width={80} height={80} />
            </div>
            <h2 className="contacted-title">Thanks for reaching out!</h2>
            <p className="contacted-subtitle">
                We’ve received your inquiry and will get back to you shortly
            </p>
        </div>
        </main>
      </div>
    </BackgroundWrapper>
  );
};

export default ContactedPage;